import type { ExploreContentItemContentOneOfReferencedTweetTweet } from './exploreContentItemContentOneOfReferencedTweetTweet';
import type { ExploreContentItemContentOneOfReferencedTweetType } from './exploreContentItemContentOneOfReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type ExploreContentItemContentOneOfReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: ExploreContentItemContentOneOfReferencedTweetTweet;
  type?: ExploreContentItemContentOneOfReferencedTweetType;
};
